import { useEffect, useState } from 'react';
export function usePagination(totalElements, defaultPageSize) {
    if (defaultPageSize === void 0) { defaultPageSize = 100; }
    var _a = useState(1), currentPage = _a[0], setCurrentPage = _a[1];
    var _b = useState(defaultPageSize), currentPageSize = _b[0], setCurrentPageSize = _b[1];
    var hasNextPage = totalElements > currentPage * currentPageSize;
    var hasPreviousPage = currentPage > 1;
    var pageStart = (currentPage - 1) * currentPageSize;
    var pageEnd = hasNextPage ? currentPage * currentPageSize : totalElements;
    var numberOfPages = Math.ceil(totalElements / currentPageSize);
    useEffect(function () {
        setCurrentPage(1);
    }, [totalElements]);
    var setPageSize = function (pageSize) {
        setCurrentPageSize(pageSize);
        setCurrentPage(1);
    };
    return {
        currentPage: currentPage,
        pageStart: pageStart,
        pageEnd: pageEnd,
        currentPageSize: currentPageSize,
        hasNextPage: hasNextPage,
        hasPreviousPage: hasPreviousPage,
        setCurrentPage: setCurrentPage,
        setPageSize: setPageSize,
        totalElements: totalElements,
        numberOfPages: numberOfPages,
    };
}
